import React from 'react';
import Button from '../../Button';
import { SearchIcon } from '../../icons';

export type SearchSubmitButtonProps = {
  value?: string | number | undefined;
  onSubmit: () => void;
  isSubmitEnabledAlways?: boolean;
};

function SearchSubmitButton({
  value,
  onSubmit,
  isSubmitEnabledAlways,
}: SearchSubmitButtonProps) {
  return (
    <Button
      className="elmo-search__btn-submit"
      isText={true}
      icon={<SearchIcon />}
      onClick={value || isSubmitEnabledAlways ? onSubmit : undefined}
      isDisabled={!value && !isSubmitEnabledAlways}
    />
  );
}

export default SearchSubmitButton;
